import { Component, computed } from '@angular/core';
import { SidebarService } from '@core/components/sidebar/service/sidebar.service';
import {
  FaIconComponent,
  FaIconLibrary,
} from '@fortawesome/angular-fontawesome';
import { toSignal } from '@angular/core/rxjs-interop';
import { faAnglesLeft, faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { TooltipTriggerDirective } from '@group24ag/flowkit';

@Component({
  selector: 'app-sidebar-toggle',
  imports: [FaIconComponent, TooltipTriggerDirective],
  template: `
    <button
      flkTooltipTrigger
      class="cursor-pointer"
      (click)="onClicked()"
      [attr.aria-label]="label()"
      [class.w-full]="collapsed()"
      [tooltip]="label()"
      [position]="'right'"
      [showDelay]="300">
      <fa-icon
        class="hover:text-greenish-500 dark:hover:text-greenish-500 fa-lg transition-transform"
        [icon]="['fas', 'chevron-left']"
        [class.rotate-180]="collapsed()" />
    </button>
  `,
})
export class SidebarToggleComponent {
  /**
   * PROPERTIES
   */
  private readonly shortcutLabel = 'Ctrl + b';
  private ariaLabel = computed(() => (this.collapsed() ? 'Open' : 'Collapse'));
  label = computed(() => `${this.ariaLabel()} ${this.shortcutLabel}`);
  collapsed = toSignal(this.sidebarService.sidebarCollapsed$);

  constructor(
    library: FaIconLibrary,
    private sidebarService: SidebarService
  ) {
    library.addIcons(faAnglesLeft, faChevronLeft);
  }

  onClicked(): void {
    if (this.collapsed()) {
      this.onOpenClicked();
    } else {
      this.onCollapseClicked();
    }
  }

  onOpenClicked(): void {
    this.sidebarService.open();
  }

  onCollapseClicked(): void {
    this.sidebarService.collapse();
  }
}
